"use client";
import { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  { id: 1, videoSrc: "/video/testimonial1.mp4" },
  { id: 2, videoSrc: "/video/testimonial2.mp4" },
  { id: 3, videoSrc: "/video/testimonial3.mp4" },
  { id: 4, videoSrc: "/video/testimonial4.mp4" },
  { id: 5, videoSrc: "/video/testimonial5.mp4" },
];

export default function TestimonialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    beforeChange: (_: number, next: number) => setActiveIndex(next),
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    customPaging: (i: number) => (
      <div
        className={`w-3 h-3 rounded-full ${
          i === activeIndex ? "bg-orange-600" : "bg-gray-300"
        }`}
      />
    ),
    responsive: [
      {
        breakpoint: 1280, // xl
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024, // lg
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640, // sm
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  function SampleNextArrow(props: any) {
    const { onClick } = props;
    return (
      <Button
        className="!absolute !right-2 top-1/2 -translate-y-1/2 z-10 !rounded-full !bg-white shadow-md"
        icon={<RightOutlined />}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { onClick } = props;
    return (
      <Button
        className="!absolute !left-2 top-1/2 -translate-y-1/2 z-10 !rounded-full !bg-white shadow-md"
        icon={<LeftOutlined />}
        onClick={onClick}
      />
    );
  }

  return (
    <div className="relative mb-10 px-4">
      <div className="bg-white rounded-lg overflow-hidden">
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="p-4">
              <video controls className="w-full rounded-lg shadow-lg">
                <source src={testimonial.videoSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
